export const colorPalettes = [
  [
    '#f95d6ace',
    '#2f4b7cc0',
    '#4361eec0',
    '#665191c0',
    '#d45087c0',
    '#58508dc0',
    '#a05195c0',
    '#ff7c43c0',
    '#ffa600c0',
    '#4895efc0',
    '#bc5090c0',
    '#4cc9f0c0',
    '#ffa07ac0',
    '#ff6361c0',
  ],
  [
    '#14213d',
    '#023047',
    '#0077b6',
    '#0096c7',
    '#00b4d8',
    '#48cae4',
    '#90e0ef',
    '#ade8f4',
    '#caf0f8',
    '#6d597a',
    '#b56576',
    '#e56b6f',
    '#eaac8b',
    '#ffba08',
    '#faa307',
  ],
  [
    '#1b263b',
    '#415a77',
    '#778da9',
    '#e0e1dd',
    '#6a0572',
    '#ab83a1',
    '#b7e4c7',
    '#95d5b2',
    '#52b788',
    '#f4a261',
    '#e76f51',
    '#f94144',
    '#f3722c',
    '#f8961e',
    '#f9c74f',
  ],
];
